import moment from "moment-timezone";

export interface Period {
  start: moment.Moment;
  end: moment.Moment;
}
export interface Periods {
  today: Period;
  yesterday: Period;
  last7days: Period;
  last30days: Period;
  thisMonth: Period;
  lastMonth: Period;
  thisYear: Period;
  lastYear: Period;
}

export function buildPeriods(timezone: string): Periods {
  const today = moment().tz(timezone).startOf("day").utc(true).local(true);
  const yesterday = today.clone().subtract(1, "day");
  const sevenDaysAgo = today.clone().subtract(7, "day");
  const thirtyDaysAgo = today.clone().subtract(30, "day");
  const startOfMonth = today.clone().startOf("month");
  const startOfYear = today.clone().startOf("year");
  const startOfLastMonth = startOfMonth.clone().subtract(1, "month");
  const endOfLastMonth = startOfLastMonth.clone().endOf("month").startOf("day");
  const startOfLastYear = today.clone().subtract(1, "year").startOf("year");
  const endOfLastYear = startOfLastYear.clone().endOf("year").startOf("day");

  const periods: Periods = {
    today: {
      start: today,
      end: today,
    },
    yesterday: {
      start: yesterday,
      end: yesterday,
    },
    last7days: {
      start: sevenDaysAgo,
      end: today,
    },
    last30days: {
      start: thirtyDaysAgo,
      end: today,
    },
    thisMonth: {
      start: startOfMonth,
      end: today,
    },
    lastMonth: {
      start: startOfLastMonth,
      end: endOfLastMonth,
    },
    thisYear: {
      start: startOfYear,
      end: today,
    },
    lastYear: {
      start: startOfLastYear,
      end: endOfLastYear,
    },
  };

  return periods;
}
